// removed by extract-text-webpack-plugin
module.exports = {"container":"ListViewTabLayout-container","tabsContainer":"ListViewTabLayout-tabsContainer"};